import React from 'react';
import { Button, Card, Col, Row, Space, Tag, Typography } from 'antd';
import {
  ExperimentOutlined,
  FolderOpenOutlined,
  PlayCircleOutlined,
  ThunderboltOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Text } = Typography;

type AppModeCardsProps = {
  compact?: boolean;
};

type ModeCard = {
  key: string;
  title: string;
  tag: string;
  icon: React.ReactNode;
  description: string;
  primaryLabel: string;
  primaryPath?: string;
  secondaryLabel?: string;
  secondaryPath?: string;
};

const AppModeCards: React.FC<AppModeCardsProps> = ({ compact = false }) => {
  const navigate = useNavigate();

  const modes: ModeCard[] = [
    {
      key: 'scenarios',
      title: 'Сценарии',
      tag: 'обучение',
      icon: <ExperimentOutlined />,
      description: 'Короткие задания с целями, ветками и comparison. Каждая попытка становится save типа scenario.',
      primaryLabel: 'Открыть каталог',
      primaryPath: '/scenarios',
      secondaryLabel: 'Мои попытки',
      secondaryPath: '/saves?type=scenario',
    },
    {
      key: 'free',
      title: 'Свободная игра',
      tag: 'save',
      icon: <ThunderboltOutlined />,
      description: 'Открывает список свободных сейвов. Новый мир создаётся сразу как save, а ферма остаётся внутренним контейнером мира.',
      primaryLabel: 'Свободные сейвы',
      primaryPath: '/saves?type=free',
      secondaryLabel: 'Сейвы free',
      secondaryPath: '/saves?type=free',
    },
    {
      key: 'saves',
      title: 'Игровые сейвы',
      tag: 'runtime',
      icon: <PlayCircleOutlined />,
      description: 'Единый список save-layer попыток: свободная игра и сценарии с курсором, revision и projection.',
      primaryLabel: 'Открыть сейвы',
      primaryPath: '/saves',
    },
  ];

  return (
    <Row gutter={[16, 16]}>
      {modes.map((mode) => (
        <Col key={mode.key} xs={24} md={12} xl={compact ? 6 : 12}>
          <Card
            size={compact ? 'small' : 'default'}
            style={{ height: '100%' }}
            title={
              <Space>
                {mode.icon}
                <span>{mode.title}</span>
              </Space>
            }
            extra={<Tag>{mode.tag}</Tag>}
          >
            <Space direction="vertical" size="middle" style={{ width: '100%' }}>
              <Text type="secondary">{mode.description}</Text>
              <Space wrap>
                <Button
                  type="primary"
                  icon={<FolderOpenOutlined />}
                  onClick={() => {
                    if (mode.primaryPath) {
                      navigate(mode.primaryPath);
                    }
                  }}
                >
                  {mode.primaryLabel}
                </Button>
                {mode.secondaryLabel && mode.secondaryPath ? (
                  <Button onClick={() => navigate(mode.secondaryPath)}>
                    {mode.secondaryLabel}
                  </Button>
                ) : null}
              </Space>
            </Space>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default AppModeCards;
